import { Input } from "@/components/ui/input";
import { formatToBrl } from "@/lib/utils";
import React from "react";

interface IntegerInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
}

const IntegerInput = ({ value, onChange, ...props }: IntegerInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digitsOnly = e.target.value.replace(/\D/g, "");

    if (!digitsOnly) {
      onChange(null);
      return;
    }

    onChange(parseInt(digitsOnly, 10));
  };

  const displayValue =
    value !== null && value !== undefined ? formatToBrl(value, 0) : "";

  return <Input {...props} value={displayValue} onChange={handleChange} />;
};

export default IntegerInput;
